module.exports = __webpack_public_path__ + "static/media/ly.42eee630.png";